import React, {memo, useEffect} from "react";
import {connect} from "formik";
import FormField from "../../../components/Form/components/FormFields";
import SubmitButton from "../../../components/Form/components/SubmitButton";
import {eventFormFields} from "../config";
import {useAuth} from "../../../hooks/auth.hook";
import {useRequest} from "../../../hooks/request.hook";


const EventFields = ({formik}) => {
    const {user, ready} = useAuth();
    const {request} = useRequest();

    useEffect(() => {
        if(ready && user && user.user_type === 2) {
            request({url: '/api/client/client/full'})
                .then(data => {
                    if(data) {
                        formik.setValues({
                            ...formik.values,
                            last_name: data.last_name || '',
                            first_name: data.first_name || '',
                            email: data.email || '',
                            phone: data.phone || ''
                        });
                    }
                });
        }

        return () => formik.resetForm(formik.initialValues)
        //eslint-disable-next-line
    }, [ready, user]);

    return (
        <>
            {eventFormFields.map(field =>
                <FormField key={field.name} {...field} />
            )}
            <div className="step-4__form-controls">
                <SubmitButton>Запись</SubmitButton>
            </div>
        </>
    )
};

export default memo(connect(EventFields));